import {
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_CLEAR_FILTERS,
  TEST_PURCHASE_FETCH_DOMAINS_SUCCESS,
  TEST_PURCHASE_SET_FILTERS_SELECTED,
} from '../../../../../actions/actionTypes';
import { getTestPurchaseDomainsAvailableIds } from '../domains';

const defaultState = [];

const domainId = (state = defaultState, action) => {
  switch (action.type) {
    case TEST_PURCHASE_SET_FILTERS_SELECTED:
      return action.payload.domainId;

    case TEST_PURCHASE_CLEAR_FILTERS:
    case TEST_PURCHASE_CLEAR:
      return defaultState;

    case TEST_PURCHASE_FETCH_DOMAINS_SUCCESS: {
      const { availableDomainIds } = getTestPurchaseDomainsAvailableIds(
        action.payload
      );

      return state.filter(id => availableDomainIds.includes(id));
    }

    default:
      return state;
  }
};

export default domainId;
